import { ColumnDef } from '@tanstack/react-table';

import { DateTimeHelper } from '@xemplo/date-time';
import { AssigneeUserInfo, PayrunAssignee } from '@xemplo/gp-types';
import { TooltipPlacement } from '@xemplo/tooltip';

import * as S from './payrun-assignee-history.styles';

const dateHelper = DateTimeHelper.with({
  format: 'DD/MM/YYYY h:mma',
});

function formatFullName(userInfo: AssigneeUserInfo | null): string {
  if (!userInfo) return '-';
  return `${userInfo.firstName} ${userInfo.lastName}`.trim();
}

export const PAYRUN_ASSIGNEE_COLUMNS: ColumnDef<PayrunAssignee>[] = [
  {
    id: 'action',
    header: 'Action',
    enableSorting: false,
    cell: ({ row }) => {
      const action = row.original.assigneeUserInfo ? 'Assigned' : 'Unassigned';
      return <span>{action}</span>;
    },
    size: 120,
  },
  {
    id: 'manager',
    header: 'User',
    enableSorting: false,
    accessorKey: 'assigneeUserInfo',
    cell: ({ getValue }) => {
      const userInfo = getValue<AssigneeUserInfo | null>();
      const fullName = formatFullName(userInfo);
      return <span>{fullName}</span>;
    },
  },
  {
    id: 'changedBy',
    header: 'Changed By',
    enableSorting: false,
    accessorKey: 'assignedByUserInfo',
    cell: ({ getValue }) => {
      const userInfo = getValue<AssigneeUserInfo | null>();
      const fullName = formatFullName(userInfo);
      return <span>{fullName}</span>;
    },
  },
  {
    id: 'date',
    header: 'Date',
    enableSorting: false,
    accessorKey: 'createdDateTimeUtc',
    cell: ({ getValue }) => {
      const date = getValue<string>();
      return <span>{dateHelper.formatString(date, { isUtc: true })}</span>;
    },
  },
  {
    id: 'notes',
    header: 'Note',
    enableSorting: false,
    accessorKey: 'notes',
    cell: ({ getValue }) => {
      const notes = getValue<string>();
      return <TableTooltip text={notes} />;
    },
  },
];

function TableTooltip({ text }: { text: string | number | null }) {
  if (!text) return '-';
  return (
    <S.InlineTooltip text={text.toString()} placement={TooltipPlacement.Top}>
      {text}
    </S.InlineTooltip>
  );
}
